const toSizeInKb = (sizeInBytes) => {
  const converted = isNaN(sizeInBytes / 1e3) ? 0 : sizeInBytes / 1e3;
  return Math.max(1, converted).toFixed();
};

export { toSizeInKb };
//# sourceMappingURL=to-size-in-kb.js.map
